import { createSelector } from 'reselect'
import makeLayoutPermissionSelector from '../../../../selectors/makeLayoutPermissionSelector'

export default () => {
  const permissionSelector = makeLayoutPermissionSelector()

  return createSelector(
    [
      permissionSelector,
    ],
    (
      permission,
    ) => ({
      permission,
    })
  )
}
